import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CCrud from "components/Molecules/Crud";
import { initialValues, structure, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { detailsData } from "./details";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetShapeRequest } from "services/modules/Wrappers/shapes";

const WrapsExtrasTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  wrapsOptionsListArray,
  selectedRow,
  colorsList,
  can_create,
  categories,
  fetchCategories,
  categoriesLoading,
  categoriesCount,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang] = useState("en");
  const [wrapId, setWrapId] = useState("en");
  const [extraType, setExtraType] = useState("");
  const [requiresText, setRequiresText] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    // const filteredData = wrapsOptionsListArray?.find((ele) => ele?.id == selectedRow?.formikData?.values?.wrap_id)
    setWrapId(selectedRow?.formikData?.values?.wrap_id);
  }, [selectedRow?.formikData?.values?.wrap_id]);

  useEffect(() => {
    if (details?.extra_type) {
      setExtraType(details.extra_type);
    }
    setRequiresText(!!details?.requires_text);
  }, [details?.extra_type, details?.requires_text]);

  useEffect(() => {
    setExtraType(selectedRow?.formikData?.values?.extra_type || "");
    setRequiresText(!!selectedRow?.formikData?.values?.requires_text);
  }, [
    selectedRow?.formikData?.values?.extra_type,
    selectedRow?.formikData?.values?.requires_text,
  ]);

  useEffect(() => {
    const requestData = {
      params: {
        page_size: 20,
        page_number: 1,
        keyword: "",
        wrap_id: wrapId,
      },
    };
    dispatch(GetShapeRequest(requestData));
  }, [wrapId, dispatch]);

  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          detailsTemplateData={{
            pageTitle: t("wrappers_wrap_extras.details"),
            data: {
              // images: [{ id: 0, img: details?.image }],
              list: detailsData({ data: details, t }),
            },
          }}
          table={{
            list: data, // data
            listTitle: t("wrappers_wrap_extras.title"), //title
            createBtnTitle: can_create && t("wrappers_wrap_extras.add"), // action
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: [
              { accessor: "id", Header: "#" },
              {
                accessor: "image",
                Header: t("common.image"),
                sort: true,
              },
              {
                accessor: "localized_data.en.name",
                Header: t("wrappers_wrap_extras.name_en"),
                sort: true,
              },
              {
                accessor: "localized_data.ar.name",
                Header: t("wrappers_wrap_extras.name_ar"),
                sort: true,
              },
              {
                accessor: "count_on_hand",
                Header: t("wrappers_wrap_extras.quantity"),
                sort: true,
              },
              {
                accessor: "price",
                Header: t("wrappers_wrap_extras.price"),
                sort: true,
              },
              {
                accessor: "price_after_discount",
                Header: t("wrappers_wrap_extras.price_after_discount"),
                sort: true,
              },
              { accessor: "Actions", Header: t("common.action_actions") },
            ],
            isSearch: false,
            searchInputPlaceholder: t(
              "wrappers_wrap_extras.search_placeholder",
            ),
            isChecked: false,
            total_count: count,
            setFilterObj,
            className:
              "organization-table system-configurations-table main-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            actionsList, //if you want to add custom actions list ...
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            // lw mafesh id add mafesh values -------- lw fe id yb2a edit values
            initialValues: !id
              ? {
                  extra_type: "",
                  requires_text: false,
                  text_max_length: "",
                  text_placeholder_en: "",
                  text_placeholder_ar: "",
                  display_priority: "",
                  for_whole_cart: false,
                }
              : initialValues(details, supportedLang),
            structure: () =>
              structure(
                t,
                categories,
                fetchCategories,
                categoriesLoading,
                categoriesCount,
                extraType,
                requiresText,
              ),
            validationSchema: validationSchema(extraType),
            deleteFun: deleteFun,
            title: id
              ? t("wrappers_wrap_extras.edit")
              : t("wrappers_wrap_extras.add"),
            submitTitle: id
              ? t("admin_users.btn_update")
              : t("admin_users.btn_add"),
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          // DetailsComponent={<Details />} //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default WrapsExtrasTemplate;
